module.exports = __webpack_public_path__ + "img/bonchorang.9747dd12.png";